var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"object_detail"},[_c('label',{staticClass:"object_detail"},[_vm._v(_vm._s(_vm.field.label))]),_c('div',{staticClass:"form-control"},[_c('a',{attrs:{"href":_vm.val,"target":"_blank"}},[_vm._v(_vm._s(_vm.field.display))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }